import React, {Component} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {getURL} from '../routes';
import {logout} from 'actions/AuthActions';

class HeaderLink extends Component {
  render() {
    return (
      <li className={(this.props.active? "active" : "")}>
        <Link to={this.props.to}>
					<span className={"glyphicon glyphicon-" + this.props.icon} aria-hidden="true"></span>
					{this.props.children}
				</Link>
      </li>
    )}
}

class NavBar extends Component {
  logoutBtnOnClick = () => {
    let { dispatch } = this.props

    dispatch(logout());
  }

  render() {
    return (
      <header className="header">
        <h3 className="text-muted pull-left">Worker System</h3>
        <ul className="nav nav-pills menu pull-right">
					<HeaderLink to={getURL("/ws-admin/site")} icon="wrench">
							工程
					</HeaderLink>
					<HeaderLink to={getURL("/ws-admin/worker")} icon="user">
							員工
					</HeaderLink>
					<HeaderLink to={getURL("/ws-admin/setting")} icon="cog">
							設定
					</HeaderLink>
          <li>
            <a href="#" onClick={this.logoutBtnOnClick}>
              <span className="glyphicon glyphicon-log-out" aria-hidden="true"></span>
              登出
            </a>
          </li>
        </ul>
      </header>
    )
  }
}

export default connect()(NavBar);


// WEBPACK FOOTER //
// ./src/components/NavBar.js